// @flow
import React from 'react';
import CONST from 'app/common/lib/Const';
// eslint-disable-next-line pinterest/no-deprecated-imports
import FormFooter from 'app/common/react/ui/deprecated/FormFooter';
import i18n from 'app/common/lib/i18n';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';
import { Box, Divider, Text } from 'gestalt';

const learnMoreUrl = CONST.GEN.templateConst.settings.HELP_BLOCKING + '?source=block_dialogue';

const HEADER_WIDTH = 320;

type Props = {|
  firstName: string,
  onBlockUser: () => void,
  onClearModal: () => void,
|};

export default function BlockWarning(props: Props) {
  const { firstName, onBlockUser, onClearModal } = props;

  return (
    <form className="standardForm" method="post">
      <Box padding={4} maxWidth={HEADER_WIDTH}>
        <Text size="xl">
          {i18n._('Block this person?', 'header text asking if we should block the user')}
        </Text>
      </Box>
      <Divider />
      <Box padding={4} data-test-id="block-text">
        <Text size="sm">
          {interpolateNamedTemplate(
            i18n._(`If you block {{ name }}, you won’t be able to follow each
  other or interact with each other’s Pins.`),
            {
              name: (
                <Text key="name" bold inline size="sm">
                  {firstName}
                </Text>
              ),
            },
          )}
        </Text>
      </Box>
      <Box padding={4}>
        <NavigateLink external to={learnMoreUrl}>
          <Text bold color="darkGray" size="sm">
            {i18n._('Learn more', 'link to help center to learn more about blocking')}
          </Text>
        </NavigateLink>
      </Box>
      <FormFooter
        confirmText={i18n._('Block')}
        isStickyFooter={false}
        onCancel={onClearModal}
        onConfirm={onBlockUser}
      />
    </form>
  );
}
